import { render, staticRenderFns } from "./SafeClasses.vue?vue&type=template&id=085c1c12&"
import script from "./SafeClasses.vue?vue&type=script&lang=js&"
export * from "./SafeClasses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports